import type { FoodCategory, Unit } from "./types";

/**
 * One tap adds these. A common item only overrides the amount — where it goes
 * and how long it keeps still come from the category rule, so there is exactly
 * one place that decides expiry.
 */
export interface CommonItem {
  name: string;
  quantity: number;
  unit: Unit;
}

/**
 * The handful of things people actually restock, per category. Kept short on
 * purpose: a grid you have to read is slower than typing the name.
 *
 * "other" is empty by design — it's the catch-all, so its menu offers only the
 * custom sheet.
 */
export const COMMON_ITEMS: Record<FoodCategory, CommonItem[]> = {
  produce: [
    { name: "Spinach", quantity: 1, unit: "pack" },
    { name: "Tomatoes", quantity: 6, unit: "pcs" },
    { name: "Carrots", quantity: 500, unit: "g" },
    { name: "Onions", quantity: 3, unit: "pcs" },
    { name: "Potatoes", quantity: 1, unit: "kg" },
    { name: "Apples", quantity: 6, unit: "pcs" },
    { name: "Bananas", quantity: 5, unit: "pcs" },
    { name: "Lettuce", quantity: 1, unit: "pcs" },
  ],
  meat: [
    { name: "Chicken breast", quantity: 500, unit: "g" },
    { name: "Chicken thighs", quantity: 600, unit: "g" },
    { name: "Ground beef", quantity: 500, unit: "g" },
    { name: "Steak", quantity: 300, unit: "g" },
    { name: "Pork chops", quantity: 400, unit: "g" },
    { name: "Bacon", quantity: 200, unit: "g" },
    { name: "Sausages", quantity: 6, unit: "pcs" },
    { name: "Salmon", quantity: 300, unit: "g" },
  ],
  dairy: [
    { name: "Milk", quantity: 2, unit: "l" },
    { name: "Butter", quantity: 250, unit: "g" },
    { name: "Cheese", quantity: 200, unit: "g" },
    { name: "Yoghurt", quantity: 500, unit: "g" },
    { name: "Cream", quantity: 250, unit: "ml" },
    { name: "Eggs", quantity: 12, unit: "pcs" },
  ],
  pantry: [
    { name: "Rice", quantity: 1, unit: "kg" },
    { name: "Pasta", quantity: 500, unit: "g" },
    { name: "Flour", quantity: 1, unit: "kg" },
    { name: "Olive oil", quantity: 500, unit: "ml" },
    { name: "Tinned tomatoes", quantity: 2, unit: "pcs" },
    { name: "Beans", quantity: 2, unit: "pcs" },
    { name: "Lentils", quantity: 500, unit: "g" },
    { name: "Sugar", quantity: 1, unit: "kg" },
  ],
  frozen: [
    { name: "Peas", quantity: 500, unit: "g" },
    { name: "Berries", quantity: 300, unit: "g" },
    { name: "Chips", quantity: 750, unit: "g" },
    { name: "Ice cream", quantity: 500, unit: "ml" },
    { name: "Pizza", quantity: 1, unit: "pcs" },
    { name: "Prawns", quantity: 200, unit: "g" },
  ],
  drinks: [
    { name: "Orange juice", quantity: 1, unit: "l" },
    { name: "Sparkling water", quantity: 6, unit: "pack" },
    { name: "Beer", quantity: 6, unit: "pack" },
    { name: "Coffee", quantity: 250, unit: "g" },
    { name: "Tea", quantity: 1, unit: "pack" },
    { name: "Cola", quantity: 2, unit: "l" },
  ],
  other: [],
};
